import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import restaurantReducer from './slices/restaurantSlice';

// Middleware to handle restaurant auto-selection and associated restaurant fetching
const restaurantMiddleware = (store) => (next) => (action) => {
    const result = next(action);
    const state = store.getState();

    // Handle restaurant auto-selection for owners
    if (action.type === 'restaurant/setRestaurants') {
        const { restaurants } = state.restaurant;
        const { selectedRestaurantId } = state.restaurant;
        const { user } = state.auth;

        // Auto-select first restaurant for owners when restaurants are loaded
        if (user?.role === 'owner' && restaurants.length > 0 && !selectedRestaurantId) {
            store.dispatch({ type: 'restaurant/setSelectedRestaurantId', payload: restaurants[0]._id });
        }
    }

    // Clear restaurants when user logs out
    if (action.type === 'auth/logout') {
        store.dispatch({ type: 'restaurant/clearRestaurants' });
    }

    return result;
};

export const store = configureStore({
    reducer: {
        auth: authReducer,
        restaurant: restaurantReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: [],
            },
        }).concat(restaurantMiddleware),
});


